import React from 'react';
import { Button, Flex, Heading, Text } from '@televet/kibble-ui';
import PostcardsImg from 'assets/images/postcards.png';
import usePersistedState from '../../../../shared/hooks/usePersistedState';
import useClinicUser from 'shared/hooks/useClinicUser';
import { useGetClinicPostcardsSettingsQuery } from 'shared/types/graphql';
import { Card } from '../../../../shared/components/Card/Card';
import { PersistedStateKeys } from '../../../../shared/enums/PersistedStateKeys';

export const PostcardsOnboardingBanner = ({ onLearnMore }: { onLearnMore: () => void }): JSX.Element | null => {
  const { currentClinicId } = useClinicUser();
  const [hiddenPostcardsCardClinics, setHiddenPostcardsCardClinics] = usePersistedState<string[]>(
    PersistedStateKeys.HiddenPostcardsCardClinics,
    [],
  );

  const handleClose = (): void => {
    currentClinicId && setHiddenPostcardsCardClinics([...hiddenPostcardsCardClinics, currentClinicId]);
  };

  const { data: postcardsData } = useGetClinicPostcardsSettingsQuery({
    variables: {
      where: {
        clinicId: currentClinicId,
      },
    },
    skip: !currentClinicId,
  });

  const arePostcardsEnabled = postcardsData?.findUniqueClinicPostcardSetting?.isRemindersEnabled;

  const hide: boolean = !!arePostcardsEnabled || hiddenPostcardsCardClinics.includes(currentClinicId || '');

  return !hide ? (
    <Card backgroundImage={PostcardsImg} my={5} backgroundSize="192px 180px" backgroundPosition="center right">
      <Heading size="sm" mb={2}>
        Send Postcard Reminders via U.S. Mail
      </Heading>
      <Text size="sm" as="p" mb={5} maxWidth="400px">
        Otto can automatically send personalized reminder postcards to your clients via U.S. Mail.
      </Text>
      <Flex>
        <Button onClick={onLearnMore}>Learn More</Button>
        <Button variant="tertiary" ml={3} onClick={handleClose}>
          Not Right Now
        </Button>
      </Flex>
    </Card>
  ) : null;
};
